import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { DatosCreacionBhe } from "../models/BoletaHonorarios/DatosCreacionBhe";
import { DatosEmisorBhe } from "../models/BoletaHonorarios/DatosEmisorBhe";
import { ResumenDetallesBhe } from "../models/BoletaHonorarios/ResumenDetallesBhe";
import { InvoicingButton } from "../shared/models/InvoicingButton.enum";

@Injectable({
	providedIn: "root",
})
export class EmisionBheService {
	private buttonBheActionSubject: Subject<InvoicingButton>;
	public buttonBheActionObservable: Observable<InvoicingButton>;
	public allowedToEmitBheObservable: Observable<boolean>;
	private allowedToEmitBheSubject: BehaviorSubject<boolean>;

	// private retencionReceptorBheSubject: BehaviorSubject<boolean>;
	// public retencionReceptorObservable: Observable<boolean>;

	private datosReceptorBheSubject: BehaviorSubject<DatosCreacionBhe>;
	public datosReceptorObservable: Observable<DatosCreacionBhe>;

	private datosEmisorBheSubject: BehaviorSubject<DatosEmisorBhe>;
	public datosEmisorBheObservable: Observable<DatosEmisorBhe>;

	private resumenDetallesBheSubject: BehaviorSubject<ResumenDetallesBhe>;
	public resumenDetallesBheObservable: Observable<ResumenDetallesBhe>;

	constructor() {
		this.buttonBheActionSubject = new Subject<InvoicingButton>();
		this.buttonBheActionObservable = this.buttonBheActionSubject.asObservable();
		this.allowedToEmitBheSubject = new BehaviorSubject<boolean>(false);
		this.allowedToEmitBheObservable = this.allowedToEmitBheSubject.asObservable();
		// this.retencionReceptorBheSubject = new BehaviorSubject<boolean>(false);
		// this.retencionReceptorObservable = this.retencionReceptorBheSubject.asObservable();
		this.datosReceptorBheSubject = new BehaviorSubject<DatosCreacionBhe>(new DatosCreacionBhe());
		this.datosReceptorObservable = this.datosReceptorBheSubject.asObservable();
		this.datosEmisorBheSubject = new BehaviorSubject<DatosEmisorBhe>(new DatosEmisorBhe());
		this.datosEmisorBheObservable = this.datosEmisorBheSubject.asObservable();
		this.resumenDetallesBheSubject = new BehaviorSubject<ResumenDetallesBhe>(new ResumenDetallesBhe());
		this.resumenDetallesBheObservable = this.resumenDetallesBheSubject.asObservable();
	}

	sendEmitAction() {
		this.buttonBheActionSubject.next(InvoicingButton.Emitir);
	}

	sendCancelAction() {
		this.buttonBheActionSubject.next(InvoicingButton.Cancelar);
	}

	setEmisorData(datos: DatosEmisorBhe) {
		this.datosEmisorBheSubject.next(datos);
	}

	setDatosReceptor(datos: DatosCreacionBhe) {
		this.datosReceptorBheSubject.next(datos);
	}

	// setRetencion(retencion: boolean) {
	// 	this.retencionReceptorBheSubject.next(retencion);
	// }

	setDetallesResumen(resumen: ResumenDetallesBhe) {
		this.resumenDetallesBheSubject.next(resumen);
	}

	resetServiceData() {
		//this.datosEmisorBheSubject.next(new DatosEmisorBhe());
		this.datosReceptorBheSubject.next(new DatosCreacionBhe());
		this.resumenDetallesBheSubject.next(new ResumenDetallesBhe());
	}
	updateRetencion() {}
}
